'use client';

import { useMemo } from 'react';

import { FilterDropdown } from '@/components';
import { useT } from '@/hooks';
import { useLeaderboardSortCategories } from '@/services/query';

interface ProfilePositionsSortMenuProps {
  tab: string;
  sortBy: string;
  onSortChange: (key: string) => void;
  effectiveSortBy: string;
}

export const ProfilePositionsSortMenu = ({
  tab,
  sortBy,
  onSortChange,
  effectiveSortBy,
}: ProfilePositionsSortMenuProps) => {
  const categoryType = tab === 'Active' ? 'active-positions' : 'closed-positions';
  const { data: sortCategories } = useLeaderboardSortCategories(categoryType);
  const { t } = useT();

  const options = useMemo(() => {
    return (sortCategories || []).map((cat) => ({
      value: cat.key,
      label: t(cat.label, { defaultValue: cat.label }),
    }));
  }, [sortCategories, t]);

  // If options haven't loaded yet, return a fallback layout or null
  if (!options.length) return null;

  return (
    <FilterDropdown
      value={sortBy || effectiveSortBy}
      options={options}
      onChange={onSortChange}
      minWidth={120}
      height={46}
    />
  );
};
